import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6092a850"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "justify-center" }
const _hoisted_3 = { class: "mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]" }
const _hoisted_4 = { class: "flex mt-[1.5rem]" }

import ApiService from "@/_services/api.service";
import { ref, watch } from "vue";
import router from "@/router";
import swal from "@/_helpers/swal";
import { ucfirst } from "@/_helpers/stringManipulations";
import { searchSuppliers } from "@/_services/supplier/supplier";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductStockImport',
  props: {
  importType: {
    type: String,
    required: true,
  },
  importRoute: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



let supplier_model = ref('');
let optionsProducts = ref([]);

async function fetchProductsBySupplier(supplierUuid) {
  if (!supplierUuid) {
    optionsProducts.value = [];
    return;
  }
  try {
    const response = await ApiService.get(`/variant-product-filter?supplierUuid=${supplierUuid}&prototypes[]=6a3f537e-fdfd-11ed-a0b1-de1c3c38600f&prototypes[]=6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f&prototypes[]=6a3fe435-fdfd-11ed-a0b1-de1c3c38600f&sortBy=adminProductName&isDefault=0`);
    optionsProducts.value = response.data.data.map((val: any) => {
      let productName = val?.properties?.adminProductName ? val.properties.adminProductName[0]?.value : '';
      productName = productName? productName : ' ';
      if (!val?.status?.active) {
        productName = 'Inactif -  ' + productName;
      }
      productName= val.isTechnical ? 'Technique - ' + productName : productName;
      return {
        label: productName,
        value: val.uuid,
      }
    });
  } catch (error) {
    //console.error("Error fetching products:", error);
  }
}

watch(
  supplier_model,
  (newSupplierUuid) => {
    fetchProductsBySupplier(newSupplierUuid);
  }
);


function submitHandler(data,formNode) {
  const filename = data.file[0].file.name;
  const errorMessage = 'Fichier au mauvais format';
  let formatError = null;
  if (filename.endsWith(".csv")) {
    const form = new FormData();
    form.append('file', data.file[0].file);
    form.append('variantProduct', '/api/variant-product/' + data.variantProduct);
    return ApiService.post(`/${props.importRoute}`, form)
      .then(({data}) => {
        swal.success(`${ucfirst(props.importType)} importé !`, "");
        router.push({name: `List${ucfirst(props.importType)}s`})
      })
      .catch(({response}) => {
        let contentError = null;
        if (response) {
          response.data.errors.forEach((error) => {
            if (error.message === 'Fichier au mauvais format') {
              formatError = error.message;
            } else {
              contentError = error.message;
            }
          });
          if (formatError) {
            formNode.setErrors(
              null,
              {
                file: formatError
              }
            );
          } else if (contentError) {
            formNode.setErrors(
              null,
              {
                file: contentError
              }
            );
          }
        } else {
          formatError = "format non valide";
        }
      });
  } else {
    formatError = errorMessage;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormKit, {
          type: "form",
          onSubmit: submitHandler,
          value: true,
          actions: false,
          "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
        }, {
          default: _withCtx(({ value }) => [
            _createVNode(_component_FormKit, {
              type: "autocomplete",
              label: "Fournisseur*",
              name: "supplier",
              validation: "required",
              "validation-messages": {
              required: 'Veuillez sélectionner un fournisseur.',
            },
              placeholder: "Sélectionner un fournisseur",
              options: _unref(searchSuppliers),
              modelValue: _unref(supplier_model),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(supplier_model) ? (supplier_model).value = $event : supplier_model = $event))
            }, null, 8, ["validation-messages", "options", "modelValue"]),
            _createVNode(_component_FormKit, {
              type: "autocomplete",
              label: "Produit*",
              name: "variantProduct",
              validation: "required",
              "validation-messages": {
              required: 'Veuillez sélectionner un produit.',
            },
              placeholder: "Sélectionner un produit",
              options: _unref(optionsProducts)
            }, null, 8, ["validation-messages", "options"]),
            _createVNode(_component_FormKit, {
              type: "file",
              label: "Vos documents*",
              help: "Sélectionnez les documents à uploader.",
              accept: ".csv",
              placeholder: "Pas de fichier sélectionné.",
              validation: "required|validateFileExtension:csv",
              "validation-messages": {
              required: 'Aucun fichier sélectionné.',
              validateFileExtension: 'Le fichier doit être au format CSV.'
            },
              name: "file"
            }, null, 8, ["validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "hidden",
              name: "csvFilePath"
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_FormKit, {
                type: "submit",
                label: "Importer",
                class: "btn",
                "prefix-icon": "check"
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})